module.exports = __webpack_public_path__ + "static/3-large-4877586e1637364c40fe825ece6b6cc8.jpg";